import React from "react";
import howItWorks from "../../assets/images/serviceHowItWorks.png";

const HowItWorks = () => {
  return (
    <div className="py-6 bg-[#1E1E1E] text-white px-4 jost-regular w-full sm:py-20 mx-4 sm:mx-12 flex flex-col md:flex-row gap-5 sm:gap-10 justify-center items-center">
      <div className="flex flex-col gap-4">
        <h3 className="jost-regular text-xl sm:text-2xl text-primary py-4 uppercase">
          How it works
        </h3>
        <h1 className="jost-regular text-2xl sm:text-4xl max-w-xl text-white">
          At Psyche Ethos, we believe in making the journey to mental wellness
          simple, accessible, and effective. Here’s how we guide you every step
          of the way:
        </h1>
        <div className="flex flex-col mt-4">
          <div className="flex max-w-lg">
            <div className="relative">
              <div className="absolute z-10 h-10 w-10 bg-white rounded-lg text-primary flex justify-center items-center">
                <div className="text-lg">1</div>
              </div>
              <div className="absolute h-10 w-10 bg-primary rounded-lg top-2 -left-2"></div>
            </div>
            <div className="flex flex-col ml-[13%]">
              <h3 className="text-xl sm:text-2xl">Make an Appointment</h3>
              <p>
                Start by scheduling a free consultation with one of our wellness
                experts.
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col mt-4">
          <div className="flex max-w-lg">
            <div className="relative">
              <div className="absolute z-10 h-10 w-10 bg-white rounded-lg text-primary flex justify-center items-center">
                <div className="text-lg">2</div>
              </div>
              <div className="absolute h-10 w-10 bg-primary rounded-lg top-2 -left-2"></div>
            </div>
            <div className="flex flex-col ml-[13%]">
              <h3 className="text-xl sm:text-2xl">Choose Package</h3>
              <p>
                Based on your goals and the issues you’re facing, we’ll
                recommend a package tailored to your specific needs.
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col mt-4">
          <div className="flex max-w-lg">
            <div className="relative">
              <div className="absolute z-10 h-10 w-10 bg-white rounded-lg text-primary flex justify-center items-center">
                <div className="text-lg">3</div>
              </div>
              <div className="absolute h-10 w-10 bg-primary rounded-lg top-2 -left-2"></div>
            </div>
            <div className="flex flex-col ml-[13%]">
              <h3 className="text-xl sm:text-2xl">Get Service</h3>
              <p>
                Once you’ve chosen your package, it’s time to get started with
                your personalized guidance.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="rounded-xl overflow-hidden">
        <img
          src={howItWorks}
          className="hover:scale-110 transition-all duration-300"
          alt=""
        />
      </div>
    </div>
  );
};

export default HowItWorks;
